module.exports = __webpack_public_path__ + "static/media/Turning-Your-Clunker-into-Cash.f7fb76d5.jpg";